<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <div v-if="true">
        <v-layout class="text-xs-left ml-2 mt-4 mr-2">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> assignment </v-icon>
            </v-avatar>
            Procedure
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> more_time </v-icon>
            </v-avatar>
            {{calcTaskListProgress(this.getTasksList)}}%
          </v-chip>
        </v-layout>
        <v-layout class="ml-4 mr-4">
          <v-progress-linear
            height="3"
            :background-color="ui.colorBlue"
            :color="ui.colorSuccess"
            :value="calcTaskListProgress(this.getTasksList)"
          ></v-progress-linear>
        </v-layout>
        <Tasks/>
        <v-layout class="text-xs-left ml-2 mt-4 mr-2"
        v-if="
        this.getTasksList !== null &&
        this.getTasksList !== undefined &&
        this.getTasksList.length > 0
        ">
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> running_with_errors </v-icon>
            </v-avatar>
            {{calcTaskListCompliance(this.getTasksList)}} %
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> access_time_filled </v-icon>
            </v-avatar>
            {{calcTaskListHoursActual(this.getTasksList)}} hrs
          </v-chip>
        </v-layout>
      </div>
      <div v-if="true">
        <v-layout class="text-xs-left ml-2 mt-4 mr-2">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> science </v-icon>
            </v-avatar>
            Results
          </v-chip>
          <v-spacer/>
        </v-layout>
        <Results/>
      </div>
      <div v-if="this.calcTaskListProgress(this.getTasksList) > 99">
        <v-layout class="text-xs-left ml-2 mt-4 mr-2">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> check_box </v-icon>
            </v-avatar>
            Work Confirmation
          </v-chip>
          <v-spacer/>
        </v-layout>
        <ShareDetailClose/>
      </div>
      <div>
        <v-layout row>
          <v-spacer/>
          <!-- <v-btn :color="ui.btnColor" flat dark :to="'/workrequestdetail'">
            op
          </v-btn> -->
          <!-- <GetDetailPage
          :data="{
            tag: this.getDetail.basic.tag,
            size: 'flat',
            item: this.getDetail}"
          /> -->
        </v-layout>
      </div>
      <v-layout row class="mb-4">
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import tasksFunctions from "@/data/functions/mixins/tasksFunctions.js";
import ShareDetailClose from "@/support/share/components/ShareDetailClose";
import Tasks from "@/work/tasks/components/Tasks";
import Results from "@/engineering/results/components/Results";
// import GetDetailPage from "@/support/detail/components/GetDetailPage";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme, numberFunctions, dateFunctions, tasksFunctions],
  components: {
    Tasks,
    Results,
    ShareDetailClose
    // GetDetailPage
  },
  computed: {
    ...mapGetters(["getDetail", "getTasksList"])
  }
};
</script>
